import { render, staticRenderFns } from "./ReviewRequestProSpecialtiesModal.vue?vue&type=template&id=eed32d98&"
import script from "./ReviewRequestProSpecialtiesModal.vue?vue&type=script&lang=js&"
export * from "./ReviewRequestProSpecialtiesModal.vue?vue&type=script&lang=js&"
import style0 from "./ReviewRequestProSpecialtiesModal.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports